import React from "react";
import ESIPage from "@/components/esi-page/ESIPage";
import { capitalize } from "lodash";

function generateMetadata(params) {
  const title = params.slug?.[0]?.split("-").map(capitalize).join(" ");
  return {
    title: title || "Prices and Payment",
    description:
      "Learn about our payment options. Find out how to use gift cards and vouchers, check your gift card balance, and get a VAT receipt for your order.",
  };
}

function Page() {
  return <ESIPage />;
}

Page.generateMetadata = generateMetadata;

export default Page;
